// Single source of truth for company details shown across the site.
// Keep public/index.html (JSON-LD) in sync when changing the address or socials.

export const BOOKING_URL = "https://cal.com/tushar-beladiya/discovery-call";

export const CONTACT = {
  email: "hello@dobedosoft.com",
  phone: "+91 6352 746259",
  phoneHref: "tel:+916352746259",
};

export const ADDRESS = {
  line1: "C1 - 901, Pragati IT Park",
  line2: "Mota Varachha, Surat, Gujarat 394101",
  country: "India",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent("Pragati IT Park, Mota Varachha, Surat, Gujarat 394101"),
};

export const SOCIALS = [
  { label: "LinkedIn", icon: "fa-brands fa-linkedin-in", href: "https://in.linkedin.com/company/dobedo-soft" },
  { label: "Instagram", icon: "fa-brands fa-instagram", href: "https://www.instagram.com/dobedosoft/" },
];

export const SERVICES = [
  { name: "AI & Generative AI", desc: "Agents, RAG, copilots & automation", icon: "fa-robot", path: "/generative-ai" },
  { name: "Web Applications", desc: "Scalable SaaS & web platforms", icon: "fa-laptop-code", path: "/web-applications" },
  { name: "Mobile Applications", desc: "iOS, Android & cross-platform", icon: "fa-mobile-screen", path: "/mobile-applications" },
  { name: "Backend & APIs", desc: "Cloud, integrations & data", icon: "fa-server", path: "/backend-api-development" },
  { name: "MVP Development", desc: "Idea to launch, fast", icon: "fa-rocket", path: "/mvp-development" },
];

// Our own products. Client projects are listed (without links) on the Work page only.
export const PRODUCTS = [
  { name: "Snow Resume", url: "https://www.snowresume.com" },
  { name: "Rapid Sender", url: "https://rapid-sender.com" },
];
